import { CLOUDFRONT_URL } from './globals';

interface IPresetModel {
    name: string;
    url: string;
    thumbnail: string;
}

export const ModelList: IPresetModel[] = [
    // {
    //     name: 'Scanwatch',
    //     url: CLOUDFRONT_URL+'withings/ScanWatch2.glb',
    //     thumbnail: 'https://asset.naker.io/image/thumbnail/Airpods.png'
    // },
    {
        name: 'Airpods',
        url: `${CLOUDFRONT_URL}3btvrjuyypxchg8gaj7lym/scene.glb`,
        thumbnail: 'https://asset.naker.io/image/thumbnail/Airpods.png'
    },
    {
        name: 'Headphones',
        url: `${CLOUDFRONT_URL}hpjutut16iwr7byaf43unl/scene.glb`,
        thumbnail: 'https://pngimg.com/uploads/headphones/headphones_PNG7645.png'
    },
    {
        name: 'Rocking chair',
        url: `${CLOUDFRONT_URL}8i6p2ip1w5573jg6z8kv9k/scene.glb`,
        thumbnail: 'https://pngimg.com/uploads/chair/chair_PNG6843.png'
    },
    {
        name: 'Watch',
        url: `${CLOUDFRONT_URL}yv83ju6v28ezr412ojhew/scene.glb`,
        thumbnail: 'https://e7.pngegg.com/pngimages/758/778/png-clipart-pocket-watch-chronograph-watch-watch-accessory-accessories.png'
    },
    {
        name: 'Jewel',
        url: 'https://asset.naker.io/model/Rings/silver_ring.glb',
        thumbnail: 'https://e7.pngegg.com/pngimages/319/408/png-clipart-jewellery-wedding-ring-gold-diamond-ring-love-gemstone.png'
    },
    {
        name: 'Shoes',
        url: `${CLOUDFRONT_URL}68t9zt0z4ulnjuwec5z5xn/scene.glb`,
        thumbnail: 'https://e7.pngegg.com/pngimages/88/948/png-clipart-shoe-shoes-brown-leather.png'
    },
];
